<template>
  <div class="min-h-full">
      <Disclosure as="nav" class="bg-white shadow-sm" v-slot="{ open }">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div class="flex h-16 justify-between">
            <div class="flex">

                <div class="relative flex flex-1 m-2">
                  <slot name="networkLogo" />
                  <slot name="logo" />
                </div>

              <div class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                <a v-for="item in navigation" :key="item.name" :href="item.href" :class="[item.current ? 'border-gray-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium']" :aria-current="item.current ? 'page' : undefined">{{ item.name }}</a>
              </div>
            </div>
            <div class="hidden sm:ml-6 sm:flex sm:items-center">
<!--              <button type="button" class="relative rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">-->
<!--                <span class="absolute -inset-1.5" />-->
<!--                <span class="sr-only">View notifications</span>-->
<!--                <BellIcon class="h-6 w-6" aria-hidden="true" />-->
<!--              </button>-->

              <!-- Profile dropdown -->
              <Menu as="div" class="relative ml-3">
                <div>
                  <MenuButton class="relative flex rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
                    <span class="absolute -inset-1.5" />
                    <span class="sr-only">Open user menu</span>
                    <img class="h-8 w-8 rounded-full" :src="profilePhotoSrc" alt="" />
                  </MenuButton>
                </div>
                <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                  <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
                      <a :href="item.href" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">{{ item.name }}</a>
                    </MenuItem>
                  </MenuItems>
                </transition>
              </Menu>
            </div>
            <div class="-mr-2 flex items-center sm:hidden">
              <!-- Mobile menu button -->
              <DisclosureButton class="relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
                <span class="absolute -inset-0.5" />
                <span class="sr-only">Open main menu</span>
                <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
                <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
              </DisclosureButton>
            </div>
          </div>
        </div>

        <DisclosurePanel class="sm:hidden">
          <div class="space-y-1 pb-3 pt-2">
            <DisclosureButton v-for="item in navigation" :key="item.name" as="a" :href="item.href" :class="[item.current ? 'border-gray-500 bg-gray-50 text-gray-700' : 'border-transparent text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800', 'block border-l-4 py-2 pl-3 pr-4 text-base font-medium']" :aria-current="item.current ? 'page' : undefined">{{ item.name }}</DisclosureButton>
          </div>
          <div class="border-t border-gray-200 pb-3 pt-4">
            <div class="flex items-center px-4">
              <div class="flex-shrink-0">
                <img class="h-10 w-10 rounded-full" :src="profilePhotoSrc" alt="" />
              </div>
              <div class="ml-3">
                <div class="text-base font-medium text-gray-800">{{ user.account.name }}</div>
              </div>
              <button type="button" class="relative ml-auto flex-shrink-0 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
                <span class="absolute -inset-1.5" />
                <span class="sr-only">View notifications</span>
                <BellIcon class="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div class="mt-3 space-y-1">
              <DisclosureButton v-for="item in userNavigation" :key="item.name" as="a" :href="item.href" class="block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800">{{ item.name }}</DisclosureButton>
            </div>
          </div>
        </DisclosurePanel>
      </Disclosure>

    <div class="py-10">
<!--      <header>-->
<!--        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">-->
<!--          <h1 class="text-3xl font-bold leading-tight tracking-tight text-gray-900">Dashboard</h1>-->
<!--        </div>-->
<!--      </header>-->
      <main>
        <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
          <slot name="content" />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import {Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/vue";
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/vue/24/outline'

export default {
  name: "MainAccountComponent",
  props: {
    profilePhotoSrc: {
      type: String,
      default: '/img/user.png',
    }
  },
  components: {
    DisclosurePanel,
    DisclosureButton,
    MenuItem,
    MenuItems,
    MenuButton,
    Disclosure,
    Bars3Icon,
    BellIcon,
    XMarkIcon,
    Menu,
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      sidebarOpen: false,
      navigation: [
        { name: 'Dashboard', href: '/dashboard', current: false },
      ],
      userNavigation: [
        { name: 'Your profile', href: '/account' },
        { name: 'Sign out', href: '/auth/logout' },
      ],
    }
  },
}
</script>
